import { c as _c } from "react/compiler-runtime";
import React from "react";
const LogoIcon = t0 => {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <rect fill="none" x="450.9" y="1265.5" width="1018.2" height="67.9" />;
    t2 = <rect fill="none" x="450.9" y="586.7" width="1018.2" height="67.9" />;
    t3 = <g><polygon fill="currentColor" points="0 1016.5 790.6 1016.5 790.6 1129.4 0 1129.4 0 1242.3 903.5 1242.3 903.5 903.5 112.9 903.5 112.9 790.6 1807.1 790.6 1807.1 903.5 1016.5 903.5 1016.5 1242.3 1920 1242.3 1920 1129.4 1129.4 1129.4 1129.4 1016.5 1920 1016.5 1920 677.7 0 677.7 0 1016.5" /><path fill="currentColor" d="M0,1694.2h1807.1v112.9H0v112.9h1920v-564.7H0v338.8ZM112.9,1468.2h1694.2v112.9H112.9v-112.9h0Z" /><path fill="currentColor" d="M1920,112.9V0H0v564.7h1920V225.8H112.9v-112.9h1807.1,0ZM1807.1,338.8v112.9H112.9v-112.9h1694.2Z" /></g>;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== className) {
    t4 = <svg className={className} id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1920 1920">{t1}{t2}{t3}</svg>;
    $[3] = className;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default LogoIcon;